import React, { useState } from 'react';
import { Pagination, Table } from 'antd';

import { TColumns, TUnionTableData } from 'shared/types/types';

import { NavigatesAndAgreement } from 'features/vacations/navigatesAndAgreement';
import { RowSelectionType, TableRowSelection } from 'antd/lib/table/interface';
import { useNavigate } from 'react-router-dom';
import { usePath, useScrollUpPage } from 'shared/hooks';
import { TPreparedAbsenceData } from 'shared/types/absence.types';
import SearchComponent from 'shared/components/search/news-faq';
import { SearchKeysNews } from 'shared/enums/news';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TProps = {
  dataSource: TUnionTableData;
  columns: TColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  tabKey: string;
  //для раздела "Неявки"
  rowSelectionType?: RowSelectionType | false;
  onSearch?: (data: string, key: SearchKeysNews) => void;
  onRowClick?: (record: TColumns[number]) => void;
};

export const TableArchive = ({
  dataSource,
  columns,
  currentPage,
  setCurrentPage,
  total,
  tabKey,
  currentSize,
  setCurrentSize,
  rowSelectionType = 'radio',
  onSearch,
  onRowClick,
}: TProps) => {
  const navigate = useNavigate();
  const mainPath = usePath(1);

  const [selectUser, setSelectUser] = useState<TUnionTableData>();

  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  const rowSelection: TableRowSelection<TUnionTableData[number]> | undefined = {
    onChange: (_: React.Key[], selectedRows: TUnionTableData) => {
      setSelectUser(selectedRows);
    },
  };

  const onRow = (record: TColumns[number]) => ({
    onClick: () => {
      onRowClick?.(record);
      if (mainPath === 'absence' && tabKey === 'otherArchive') {
        navigate(`/absence/archive/user/subordination/${(record as TPreparedAbsenceData).id}`);
      }
      if (mainPath === 'absence' && tabKey === 'myArchive') {
        navigate(`/absence/archive/user/${(record as TPreparedAbsenceData).id}`);
      }
    },
  });

  useScrollUpPage(currentPage);

  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysNews.SEARCH_NAME]: {
            name: SearchKeysNews.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysNews.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysNews.SEARCH_ID]: {
            name: SearchKeysNews.SEARCH_ID,
            alias: 'Номер заявки',
            node: NumberFormItem({
              name: SearchKeysNews.SEARCH_ID,
              placeholder: 'Введите номер заявки',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.SEARCH_ID);
              },
            }),
          },
          [SearchKeysNews.PERSONNEL_NUMBER]: {
            name: SearchKeysNews.PERSONNEL_NUMBER,
            alias: 'ТН',
            node: StringFormItem({
              name: SearchKeysNews.PERSONNEL_NUMBER,
              placeholder: 'Введите ТН',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.PERSONNEL_NUMBER);
              },
            }),
          },
          [SearchKeysNews.POSITION_NAME]: {
            name: SearchKeysNews.POSITION_NAME,
            alias: 'Должность',
            node: StringFormItem({
              name: SearchKeysNews.POSITION_NAME,
              placeholder: 'Введите должность',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.POSITION_NAME);
              },
            }),
          },
          [SearchKeysNews.DIVISION_NAME]: {
            name: SearchKeysNews.DIVISION_NAME,
            alias: 'Подразделение',
            node: StringFormItem({
              name: SearchKeysNews.DIVISION_NAME,
              placeholder: 'Введите подразделение',
              onSearch: data => {
                onSearch?.(data, SearchKeysNews.DIVISION_NAME);
              },
            }),
          },
        }}
      />
      {selectUser && selectUser?.length > 0 && (
        <NavigatesAndAgreement
          id={`${selectUser[0].key}`}
          tabKey={tabKey}
          currentPage={currentPage}
          currentSize={currentSize}
        />
      )}
      <Table
        scroll={{ x: true }}
        rowSelection={
          rowSelectionType
            ? {
                type: rowSelectionType,
                ...rowSelection,
              }
            : undefined
        }
        // открыть запись по клику для раздела "Неявки"
        onRow={onRow}
        className={style.row}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          current={currentPage}
          total={total}
          pageSize={currentSize}
          showSizeChanger
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};
